import React from 'react';
import * as endpoint from './../../../Service/endpoints';
import { Button, EmptyState, Skeleton } from '../../UI/Primitives';

function EmptyCart({ signedOut, onSignIn }) {
    return (
        <div className="col-12">
            {signedOut ? (
                <EmptyState
                    kind="cart"
                    title="Sign in to see your cart"
                    description="Your cart is saved to your Voorent account, so you can pick up where you left off on any device."
                    actions={
                        <>
                            <Button variant="primary" onClick={onSignIn}>Login / Sign up</Button>
                            <Button variant="secondary" to={endpoint.getPath('furniture')}>Browse furniture</Button>
                        </>
                    }
                />
            ) : (
                <EmptyState
                    kind="cart"
                    title="Your cart is empty"
                    description="Add a few items and come back here to finish renting in a couple of steps."
                    actions={
                        <>
                            <Button variant="primary" to={endpoint.getPath('furniture')} arrow>Browse furniture</Button>
                            <Button variant="secondary" to={endpoint.getPath('appliance')}>Browse appliances</Button>
                        </>
                    }
                />
            )}
        </div>
    );
}

export function CartSkeleton() {
    return (
        <div className="col-12" aria-busy="true" aria-label="Loading your cart">
            <div className="row">
                <div className="col-12 col-md-8">
                    {[0, 1].map((n) => (
                        <div key={n} className="v-cart-skeleton">
                            <Skeleton width="96px" height="96px" radius="var(--radius-md)" />
                            <div style={{ flex: 1 }}>
                                <Skeleton width="60%" height="16px" />
                                <Skeleton width="35%" height="12px" style={{ marginTop: 12 }} />
                                <Skeleton width="25%" height="12px" style={{ marginTop: 12 }} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="col-12 col-md-4">
                    <Skeleton height="220px" radius="var(--radius-lg)" />
                </div>
            </div>
        </div>
    );
}

export default EmptyCart;
